import { CustomPageHeading } from "../../components/CustomPageHeading/CustomPageHeading";
import { theme as FooterTheme } from "../../theme/footerTheme";
import { customPalette } from "../../theme/theme";
import { FooterTextLabel } from "../renderer/components/FooterTextLabel/FooterTextLabel";

import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { Box, Container, ThemeProvider, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

import { PreselectorBtn } from "./PreselectorBtn";

export const ConfigurationPreselector = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box>
      <Container>
        <CustomPageHeading
          text={t("WEG:title.configurator.preselection")}
          //subtitle={item.name}
        />
        <Box mb={6}>
          <Typography variant="body1">
            {t("WEG:preselector.subcaption.text")}
          </Typography>
        </Box>
        <Grid container spacing={4}>
          <PreselectorBtn
            label={t("WEG:title.configurator.appCalc")}
            description={t("WEG:description.configurator.appCalc")}
            imgSrc="/img/Application.png"
            cfgObjectId="CFG_APPLICATION"
          />
          <PreselectorBtn
            label={t("WEG:title.configurator.productConfigurator")}
            description={t("WEG:description.configurator.productConfigurator")}
            imgSrc="/img/Professional.png"
            cfgObjectId="CFG_PROFESSIONAL"
          />
        </Grid>
      </Container>
      <ThemeProvider theme={FooterTheme}>
        <Box
          mt="16px"
          sx={{
            position: "fixed",
            display: "flex",
            boxShadow: "0 -15px 15px 0 rgba(0,0,0,.125)",
            backgroundColor: customPalette.primary.dark,
            bottom: 0,
            left: 0,
            right: 0,
            minHeight: "64px",
          }}
        >
          <FooterTextLabel />
        </Box>
      </ThemeProvider>
    </Box>
  );
};
